<!--
 * @Description: KaDa图画阅读馆-绘本
 * @Author: xiehuaqiang
 * @FilePath: /kada-official-web/public/pc/src/views/introduction/BooksDesc.vue
 * @Date: 2020-12-17 10:47:50
-->
<template>
    <div class='module-cont module-books'>
        <div class="text-cont">
            <div class="title-style"><span class="fzlty-zc">KaDa</span>图画阅读馆-绘本</div>
            <div class="desc-style">10000+正版绘本，让孩子阅见世界</div>
        </div>
        <div class="icon-list-cont">
            <div class="icon-item" v-for="(item, index) in iconList" :key="index">
                <img :src="item.imgUrl" alt="">
                <p v-html="item.desc" class="icon-desc"></p>
            </div>
        </div>
        <img class="mobile-icon" :src="mobileImg" alt="">
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mobileImg: '//cdn.hhdd.com/frontend/as/i/75ff5fba-9de9-5acf-acad-ad17f07db683.png',
                iconList: [
                    {
                        imgUrl: 'https://cdn.hhdd.com/frontend/as/i/8ae156ce-da81-525f-b580-08ecdeaf0789.png',
                        desc: '多元主题<br>覆盖儿童成长各方面'
                    },
                    {
                        imgUrl: 'https://cdn.hhdd.com/frontend/as/i/5e5b3d61-97b4-54fb-8039-608db3708593.png',
                        desc: '科学分龄<br>定制专属阅读方案'
                    },
                    {
                        imgUrl: 'https://cdn.hhdd.com/frontend/as/i/f844f14c-9f80-5545-af3b-c2ac3d99fda5.png',
                        desc: '智能有声<br>孩子轻松自主阅读'
                    }
                ]
            }
        },
    }
</script>

<style lang='stylus' scoped>
@import "../../style/vui/mixins"
.module-books
    background #F6F8FB
    position relative
    // margin-top px2rem2(44)
    padding px2rem2(44) px2rem2(16)
    .text-cont
        text-align center
        .title-style
            color #3F3F3F
            font-size px2rem2(18)
            font-weight 600
            color #3F3F3F
        .desc-style
            margin-top px2rem2(6)
            color #3F3F3F
            font-size px2rem2(12)
           
    //         opacity .8
    // .mobile-icon
      
    .icon-list-cont
        margin px2rem2(20) 0
        display flex
        flex-wrap nowrap
        justify-content space-around
        div:nth-child(2)
            margin 0 px2rem2(13) 
        .icon-item
            padding px2rem2(10)
            background #fff
            border-radius px2rem2(16)
            font-size px2rem2(10)
            img
                width px2rem2(50)
                height px2rem2(50)
                margin 0 auto
            
        .icon-desc
            flex 1
            text-align center
            color #666666
            font-size px2rem2(10)
                
</style>



// WEBPACK FOOTER //
// src/views/home/BooksDesc.vue